import paymentutils from '@utils/paymentutils';
import ErrorBox from '@components/common/ErrorBox';
import React, { useEffect, useRef, useState } from 'react';
const ExpressPaymentsButtonAmazonpay = (props) => {
    const buttonRef = useRef();
    const [enabled, setEnabled] = useState();
    const [error, setError] = useState();
    const [amazonPayConfiguration, setAmazonPayConfiguration] = useState();
    useEffect(() => {
        var _a, _b, _c, _d;
        if (props.paymentMethods) {
            setEnabled(!!((_b = (_a = props.paymentMethods) === null || _a === void 0 ? void 0 : _a.AdyenPaymentMethods) === null || _b === void 0 ? void 0 : _b.paymentMethods.find((p) => p.type == 'amazonpay')));
            let currentConfiguration = (_d = (_c = props.paymentMethods) === null || _c === void 0 ? void 0 : _c.AdyenPaymentMethods) === null || _d === void 0 ? void 0 : _d.paymentMethods.find(function (p) {
                if (p.type === 'amazonpay') {
                    return p;
                }
            });
            setAmazonPayConfiguration(currentConfiguration);
        }
    }, [props.paymentMethods]);
    useEffect(() => {
        let onclicked = () => {
            props.onPaymentSelected && props.onPaymentSelected();
        };
        if (enabled && props.adyenConfig) {
            // @ts-ignore
            let payprops = {
                returnUrl: props.adyenConfig.amazonPayReviewUrl,
                showPayButton: false,
            };
            // OE-6181: fix for amazonpay on CH, set ledgerCurrency to EUR
            if (window.country == 'CH') {
                payprops.configuration = {
                    merchantId: amazonPayConfiguration.configuration.merchantId,
                    publicKeyId: amazonPayConfiguration.configuration.publicKeyId,
                    region: amazonPayConfiguration.configuration.region || 'EU',
                    ledgerCurrency: 'EUR',
                    storeId: amazonPayConfiguration.configuration.storeId,
                };
            }
            else if (window.country === 'US') {
                // Only for test on US
                payprops.configuration = {
                    merchantId: amazonPayConfiguration.configuration.merchantId,
                    publicKeyId: amazonPayConfiguration.configuration.publicKeyId,
                    region: 'US',
                    ledgerCurrency: 'USD',
                    storeId: amazonPayConfiguration.configuration.storeId,
                };
            }
            paymentutils.getAdyenCheckout(props.adyenConfig, props.bag, props.paymentMethods.AdyenPaymentMethods, true, window.formSetValue).then((resolve) => {
                var _a;
                let paymentcomponent = resolve.create('amazonpay', payprops);
                paymentcomponent.mount(buttonRef.current);
                // if enabled ovveride the method
                onclicked = () => {
                    if (props && props.bag && props.bag.valid && props.bag.valid.error) {
                        setError(props.bag.valid.message);
                    }
                    else {
                        props.onPaymentSelected && props.onPaymentSelected();
                        console.info('calling submit');
                        paymentcomponent.submit();
                    }
                };
                (_a = buttonRef.current) === null || _a === void 0 ? void 0 : _a.addEventListener('click', onclicked);
            });
        }
        return () => {
            var _a;
            (_a = buttonRef.current) === null || _a === void 0 ? void 0 : _a.removeEventListener('click', onclicked);
        };
    }, [enabled, props.adyenConfig]);
    if (!enabled) {
        return React.createElement(React.Fragment, null);
    }
    return (React.createElement(React.Fragment, null,
        React.createElement("button", { ref: buttonRef, type: "button", className: "button button--secondary button--amazonpay", style: { display: enabled ? 'block' : 'block' }, "aria-label": "Amazon Pay" }),
        ' ',
        error && React.createElement(ErrorBox, { errors: [error] })));
};
export default ExpressPaymentsButtonAmazonpay;
